import { useCallback } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Form } from "@/components/controls";
import { HudForm, useHudForm } from "@/components/profile-forms/HudForm";
import type { IInspectorHud } from "@/types/users-inspectors";
import { Button, Drawer } from "@/ui-kit";

type IProps = {
  userId: number;
  hudDetail: IInspectorHud;
  onSave: (v: IInspectorHud) => void;
  onDismiss: () => void;
};

const EditModal = ({ userId, hudDetail, onSave, onDismiss }: IProps) => {
  const { t } = useTranslation();

  const handleSuccess = useCallback(
    (response: IInspectorHud) => {
      onSave(response);
      onDismiss();
    },
    [onSave, onDismiss],
  );

  const { form, onSubmit, loading } = useHudForm({
    userId,
    hudDetail,
    onSuccess: handleSuccess,
  });

  return (
    <FormProvider {...form}>
      <Drawer
        className="settings__user-modal"
        open={true}
        onOpenChange={onDismiss}
        closeOnOutsidePress={false}
      >
        <Drawer.Header title={t("label.hud_details")} />
        <Drawer.Body>
          <Form>
            <HudForm />
          </Form>
        </Drawer.Body>
        <Drawer.Footer>
          <Button onClick={onDismiss} variant="ghost" color="neutral">
            {t("action.cancel")}
          </Button>
          <Button onClick={onSubmit} loading={loading}>
            {t("action.save")}
          </Button>
        </Drawer.Footer>
      </Drawer>
    </FormProvider>
  );
};

export default EditModal;
